// localStorage plumbing for the "View as" role preview (TP-View-As).
//
// The whole auth session lives in Redux `state.auth` mirrored to the
// localStorage keys `tokens` + `user`, which `setCredentials` overwrites on
// every swap. The superuser's own session therefore has to be stashed under a
// SEPARATE key that setCredentials never touches, so it survives both the
// swap into the target user and a hard refresh mid-preview.
//
// No imports on purpose: this module is shared by the impersonation slice
// (store init) and the service/hook layer, and must not pull in `api` (which
// imports the store — circular).

export const IMPERSONATION_ORIGIN_KEY = "impersonation_origin";
export const IMPERSONATION_RECENT_KEY = "impersonation_recent";

const RECENT_LIMIT = 5;

export const readImpersonationOrigin = () => {
  try {
    const raw = localStorage.getItem(IMPERSONATION_ORIGIN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

// Stash the acting superuser's session BEFORE the credential swap.
// Shape: { user, tokens, path } — path is where the preview started, so
// exit can return to the exact page.
export const stashImpersonationOrigin = ({ user, tokens, path }) => {
  localStorage.setItem(
    IMPERSONATION_ORIGIN_KEY,
    JSON.stringify({ user, tokens, path }),
  );
};

export const clearImpersonationOrigin = () => {
  localStorage.removeItem(IMPERSONATION_ORIGIN_KEY);
};

export const readRecentTargets = () => {
  try {
    const raw = localStorage.getItem(IMPERSONATION_RECENT_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

// Prepend a target to the recent list (deduped by account_id, capped at 5).
export const rememberRecentTarget = (target) => {
  if (!target || target.account_id == null) return;
  const next = [
    target,
    ...readRecentTargets().filter((t) => t.account_id !== target.account_id),
  ].slice(0, RECENT_LIMIT);
  try {
    localStorage.setItem(IMPERSONATION_RECENT_KEY, JSON.stringify(next));
  } catch (e) {
    // Storage full/unavailable — recent list is a convenience only.
  }
};
